import axios from 'axios';
import Cookies from 'js-cookie';
const api = axios.create({
  // baseURL: 'http://localhost:7776/api', // Replace with your backend URL
  baseURL: process.env.REACT_APP_API_BASE_URL || 'https://digitaljournaling.com/api',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Request interceptor to add JWT token to headers
api.interceptors.request.use(
  (config) => {
    const token = Cookies.get('jwtToken');
    const loginTime = Cookies.get('loginTime');
    if (loginTime) {
      const loginTimestamp = new Date(loginTime).getTime();
      const currentTimestamp = Date.now();
      const diffInHours = (currentTimestamp - loginTimestamp) / (1000 * 60 * 60);
      if (diffInHours >= 24*7) {
        Cookies.remove('jwtToken');
        Cookies.remove('userRole');
        Cookies.remove('username');
        Cookies.remove('loginTime');
        if (typeof window !== 'undefined' && window.location.pathname.includes('writerdash')) {
          window.location.href = '/login';
        }
      }
    }
    
    if (token && !config.url.includes('generateToken')) {

      config.headers['Authorization'] = `Bearer ${token}`; // Add the token to the Authorization header
    }
    return config;
  },
  (error) => Promise.reject(error)
);
// Response interceptor to handle the new API response structure
api.interceptors.response.use(
  (response) => {
    const { data } = response;
    return data; // Return only the data part for easier handling in the app
  },
  (error) => {
    console.error('API call failed:', error);
    if (error.response?.status === 401 || error.response?.data?.includes?.('JWT token is expired')) {
      alert('Session expired, redirecting to login page...');
      window.location.href = '/';
    } else if (error.response?.status === 403) {
      console.warn('Access denied (403)');
    }
    return Promise.reject(error);
  }
);
export default api;